import { HttpMethods } from 'constants/http';
import * as Sentry from '@sentry/nextjs';

interface RequestConfig extends RequestInit {
  payload?: object;
}

const AFFILIATE_CREATE = 'https://hook.us1.make.com/kf3s0d65seb8hd8ka8rbk1d3lx64jq64';
const TRADINGVIEW_SUBMIT_USERNAME =
  'https://northamerica-northeast1-workflow-automation-433919.cloudfunctions.net/Indicators-User-Added';

const post = (url: string, { payload, ...customConfig }: RequestConfig = {}) => {
  const headers = { 'content-type': 'application/json' };
  const config: RequestInit = {
    method: HttpMethods.Post,
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (payload) {
    config.body = JSON.stringify(payload);
  }

  return fetch(url, config).then(async (response) => {
    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      Sentry.withScope((_scope) => {
        Sentry.captureException(data);
      });
      return Promise.reject(data);
    }
  });
};

interface AffiliateCreatePayload {
  id: string;
  username: string;
  email: string | null;
}
export const createAffiliateAccount = async (payload: AffiliateCreatePayload) => {
  return post(AFFILIATE_CREATE, { payload, headers: {} });
};

interface TradingviewCreatePayload {
  id: string;
  email: string | null;
  tradingviewUsername: string;
  tradingviewUsernameCaseSensitive: string;
}
export const submitTradingviewUsername = async (payload: TradingviewCreatePayload) => {
  return post(TRADINGVIEW_SUBMIT_USERNAME, {
    payload: { ...payload, appUrl: process.env.APP_URL },
    headers: {},
  });
};
